import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Directives
import { AccessDirective } from '../directives/access/access.directive';
import { DisableIfNoAccessDirective } from '../directives/access/disable-if-no-access.directive';

// Pipes
import { AccessPipe } from '../pipes/access/access.pipe';

/**
 * Shared module for access control directives and pipes
 * 
 * Import this module in any feature module that needs to use access control in templates:
 * 
 * @example
 * ```typescript
 * @NgModule({
 *   imports: [
 *     CommonModule,
 *     SharedAccessModule
 *   ]
 * })
 * export class AdministrationModule {}
 * ```
 * 
 * Available directives:
 * - *hasAccess: Show/hide elements based on permission
 * - [disableIfNoAccess]: Disable elements if user lacks required access
 * 
 * Available pipes:
 * - hasAccess: Check permission access in templates
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // Directives
    AccessDirective,
    DisableIfNoAccessDirective,
    // Pipes
    AccessPipe
  ],
  exports: [
    // Directives
    AccessDirective,
    DisableIfNoAccessDirective,
    
    // Pipes
    AccessPipe
  ]
})
export class SharedAccessModule {}
